import { jsx as l } from "react/jsx-runtime";
const r = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M34.702 19.175h-5.41V17.53l1.471-1.65V9.371h2.474v6.508l1.471 1.65v1.642l3-.804v-1.98l-1.471-1.65V6.371h-8.474v8.365l-1.471 1.65v5.788h9.213l-.803-3ZM32.159 24.585l9.309 34.543h4.142l-9.309-34.543H32.16ZM22.612 59.128l9.31-34.543h-4.144L18.47 59.128h4.143ZM18.756 21.616l5.606 5.59-.603 2.223-6.797-6.777 1.794-1.036ZM15.977 23.22l4.69 17.602-1.046 3.848-5.438-20.414 1.794-1.036ZM51.196 20.417l-3.605-2.082.67-1.161 1.539-.508 2.414-4.182 1.74 1.005-2.414 4.182.33 1.586-.665 1.15 2 .535.777-1.345-.329-1.586 3.034-5.254-5.205-3.005-3.033 5.254-1.538.508-2.052 3.553 5.801 3.35.536-2ZM45.291 21.616l-5.606 5.59.603 2.223 6.797-6.777-1.794-1.036ZM48.07 23.22l-4.689 17.602 1.045 3.848 5.438-20.414-1.794-1.036ZM16.453 18.425l-3.604 2.082-.67-1.16.328-1.587-2.415-4.181 1.74-1.005 2.415 4.181 1.538.508.664 1.15 1.464-1.465-.777-1.346-1.538-.507-3.034-5.254-5.204 3.006 3.034 5.254-.329 1.585 2.052 3.553 5.8-3.35-1.464-1.464Z"
      }
    )
  }
);
export {
  r as StrobeLights
};
